<template>
  <div>
    <div class="login-panel">
      <div class="main">
        <div class="left">
          <h2 class="title">{{$t('title')}}</h2>
          <form class="form" @submit.prevent="save">
            <div
              class="form-group"
              :class="{active: form.identity || formFocus.identity, error: $v.form.identity.$error}"
            >
              <p class="label">{{$t('username')}}</p>
              <input
                class="input"
                autocomplete="off"
                autofocus="autofocus"
                @focus="focus('identity')"
                @blur="blur('identity')"
                v-model.trim="form.identity"
                type="text"
              >
              <vd-tips path="form.identity"/>
            </div>
            <div
              class="form-group"
              :class="{active: form.password || formFocus.password, error: $v.form.password.$error}"
            >
              <p class="label">{{$t('password')}}</p>
              <input
                class="input"
                autocomplete="off"
                @focus="focus('password')"
                @blur="blur('password')"
                v-model.trim="form.password"
                type="password"
              >
              <vd-tips path="form.password"/>
            </div>
            <div class="form-group m-b-20">
              <input class="checkbox" type="checkbox" v-model="agreeRule">
              <i18n path="agree" class="fl" tag="span">
                <router-link
                  target="_blank"
                  place="service"
                  :to="iPath('/termsService')"
                >{{$t('service')}}</router-link>
                <router-link
                  target="_blank"
                  place="policy"
                  :to="iPath('/privacyPolicy')"
                >{{$t('policy')}}</router-link>
              </i18n>
            </div>
            <button :class="{disabled: !agreeRule}" class="submit" type="submit">{{$t('title')}}</button>
          </form>
          <p class="tips">
            <router-link :to="iPath('/forgotPassword')">{{$t('forgotPassword')}}</router-link>
          </p>
        </div>
        <div class="right"></div>
      </div>
      <ul class="footer">
        <li>
          <router-link :to="iPath('/termsService')">{{$ct('termsService')}}</router-link>
        </li>
        <li>
          <router-link :to="iPath('/privacyPolicy')">{{$ct('privacyPolicy')}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { post } from '@/utils/ajax'
import { required, validationMixin } from '@/utils/mixin_validate'
export default {
  inject: ['iPath'],
  mixins: [validationMixin({ tipsType: '' })],
  beforeRouteEnter({ query: { code } }, from, next) {
    if (code) store.commit('LOGIN', { token: code })
    if (store.state.token) return next('/')
    next()
  },
  data() {
    return {
      formFocus: {
        identity: false,
        password: false
      },
      form: {
        identity: '',
        password: ''
      },
      agreeRule: true
    }
  },
  validations: {
    form: {
      identity: {
        required
      },
      password: {
        required
      }
    }
  },
  computed: {
    validators() {
      return {
        form: {
          identity: {
            required: this.$ct('messages.required')
          },
          password: {
            required: this.$ct('messages.required')
          }
        }
      }
    }
  },
  mounted() {
    this.$forceUpdate()
  },
  methods: {
    focus(item) {
      this.formFocus[item] = true
    },
    blur(item) {
      this.formFocus[item] = false
    },
    async save() {
      if (!this.agreeRule) return
      await this.validationTouch()
      const { token } = await post('/edu/zone/login', this.form)
      this.$store.commit('LOGIN', { token })
      this.$router.push(this.iPath('/'))
    }
  }
}
</script>
<i18n lang="yaml">
en:
  title: Log In
  forgotPassword: Forgot Password
  username: username/email
  password: password
  agree: 'I agree {service} and {policy}'
  service: Terms of Service
  policy: Privacy Policy
zh-CN:
  title: 登 录
  forgotPassword: 忘记密码
  username: 用户名/邮箱
  password: 密码
  agree: '我同意 {service} 和 {policy}'
  service: 《服务条款》
  policy: 《隐私协议》
zh-TW:
  title: 登 錄
  forgotPassword: 忘記密碼
  username: 用戶名/郵箱
  password: 密碼
  agree: '我同意 {service} 和 {policy}'
  service: 《服務條款》
  policy: 《隱私協議》
it:
  title: Accesso
  forgotPassword: Password dimenticata
  username: username/e-mail
  password: password
  agree: 'Accetto i {service} e {policy}'
  service: Termini di servizio
  policy: Privacy Policy
id:
  title: Masuk
  forgotPassword: Lupa kata sandi
  username: nama pengguna / E-mail
  password: kata sandi
  agree: 'Saya menyetujui {service} dan {policy}'
  service: Ketentuan Layanan
  policy: Kebijakan Data Pribadi
</i18n>
